// src/context/SelectedItemContext.tsx

import React, { createContext, useContext, useState } from 'react';

interface SelectedItemContextType {
  selectedItemName: string | null;
  setSelectedItemName: (name: string) => void;
  specializations: string | null; // Yangi state specializations uchun
  setSpecializations: (specializations: string | null) => void; // Yangi setter funksiyasi
}

const SelectedItemContext = createContext<SelectedItemContextType | undefined>(undefined);

export const SelectedItemProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedItemName, setSelectedItemName] = useState<string | null>(null);
  const [specializations, setSpecializations] = useState<string | null>(null); // specializations uchun state

  return (
    <SelectedItemContext.Provider value={{ selectedItemName, setSelectedItemName, specializations, setSpecializations }}>
      {children}
    </SelectedItemContext.Provider>
  );
};

export const useSelectedItem = (): SelectedItemContextType => {
  const context = useContext(SelectedItemContext);
  if (!context) {
    throw new Error('useSelectedItem must be used within a SelectedItemProvider');
  }
  return context;
};
